import { FETCH_PROGRAM_CATS } from '../actionTypes';

const initialState = {
};

export default function(state = initialState, action=null){
  if (action.type === FETCH_PROGRAM_CATS) {
    return {...state, ...action.payload};
  } else {
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/programCats.js